import React, { useState, useEffect } from "react";
import { Form, Row } from "react-bootstrap";
import { CCol, CFormLabel, CFormFeedback, CFormInput, CButton } from "@coreui/react";
import { useDispatch } from "react-redux";

import { toastMessage } from "../../../helpers/utility.js";
import { addLedger, editLedger, getMasterList } from "../../../redux/slices/LedgerSlice.js";
import FormWrapper from "../../../pagecomponents/Common/FormWrapper.js";
import { getBasicdata } from "../../../redux/slices/BasicDataSlice.js";

const INIT_FORM_DATA = {
    ledger_Id: 0,
    client_Id: 1,
    ledger_Name: "",
    ledger_type: "",
    ledger_group_Id: "",
    ledger_Opening_Balance: "",
    type: "",
};

const LedgerAddEdit = ({reloadList, mode, data, closeModal}) => {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState(INIT_FORM_DATA);
    // const [isSaving, setIsSaving] = useState(false);
    const [isSaveDisabled, setIsSaveDisabled] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const PARAMS = {
        skip: 0,
        take: rowsPerPage,
        type: "ledger_group",
        sorting: 'asc',
        sorting_key: 'created_at',
        filter: {
            
        }
    };
    const [params, setParams] = useState(PARAMS);
    const [masterData, setMasterData] = useState([]);

    useEffect(() => {
        fetchBasicData();
        fetchMasterData();
    }, []);

    const fetchMasterData = async () => {
        try {
            const { payload } = await dispatch(getMasterList({ inputData: params }));
            setMasterData(payload?.ledger_group || []);
        } catch (err) {
            toastMessage("error", "Failed to fetch data");
        } finally {
            
        }
    };

    const fetchBasicData = async () => {
        try {
            const { payload } = await dispatch(getBasicdata({}));
            console.log("Payload from API:", payload);

            if (payload && payload.client_Id) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    client_Id: payload.client_Id,
                }));
                console.log("Updated formData:", formData);
            } else {
                toastMessage("error", "client_Id is missing in the response");
            }
            
        } catch (err) {
            toastMessage("error", "Failed to fetch basic data");
        } finally {
        }
    };

    useEffect(() => {
        if (mode && data) {
            setFormData({
                ledger_Id: data.ledger_Id || "",
                client_Id: data.client_Id || "",
                ledger_Name: data.ledger_Name || "",
                ledger_type: data.ledger_type || "",
                ledger_group_Id: data.ledger_group_Id || "",
                ledger_Opening_Balance: data.ledger_Opening_Balance || "",
                type: data.type || "",
            });
        }
    }, [mode, data]);

    const handleInputChange = (e) => {
        const {name, value} = e.target;
                        
        // Check for special characters in customer_Name
        // if (name === "ledger_Name") {
        //     const isValid = value === "" || /^[a-zA-Z\s]+$/.test(value); // Allows only letters and spaces
        //     if (!isValid) {
        //         toastMessage("error", "Special characters are not allowed in the input.");
        //         return;
        //     }
        // }

        // if (name === "ledger_Opening_Balance") {
        //     if (/^\d*$/.test(value)) { // Allows only digits
        //         setFormData((prevData) => ({ ...prevData, [name]: value }));
        //     }
        //     return; // Prevent further execution
        // }

        if (name === "ledger_Opening_Balance") {
            if (value === "" || /^\d*\.?\d*$/.test(value)) { // Allows empty value and decimal numbers
                setFormData((prevData) => ({ ...prevData, [name]: value }));
            }
            return;
        }
        
        setFormData({...formData, [name] : value});
    };

    const handleSave = async () => {
        const selectedLedgerGroupId = Number(formData.ledger_group_Id);
        if (!Number.isInteger(selectedLedgerGroupId) || selectedLedgerGroupId <= 0) {
            toastMessage("error", "Please select Under");
            return;
        }

        setIsSaveDisabled(true);
        try {
            let api = mode ? editLedger : addLedger;
            const inputData = {
                ...formData,
                ledger_group_Id: selectedLedgerGroupId,
            };
            const { payload } = await dispatch(api({ inputData }));
            if (payload?.status === "success") {
                toastMessage("success", payload?.msg || "Saved successfully.");
                reloadList();
            } else {
                toastMessage("error", payload.msg || "An error occurred.");
            }
        } finally {
            setIsSaveDisabled(false);
        }
    };

    return(
        <FormWrapper onSubmit={handleSave}>
            <Row className="row-xs mb-2">
                <CCol md={12}>
                    <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="ledger_Name">Name</CFormLabel>
                    <CFormInput
                        type="text"
                        id="ledger_Name"
                        name="ledger_Name"
                        value={formData.ledger_Name}
                        onChange={handleInputChange}
                        required
                        // pattern="^[a-zA-Z\s]+$" // Ensures no special characters
                    />
                    <CFormFeedback invalid>Enter name</CFormFeedback>
                </CCol>
            </Row>
            <Row className="row-xs mb-2">
                <CCol md={12}>
                    <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="ledger_group_Id">Under</CFormLabel>
                    <Form.Select
                        className="form-control"
                        id="ledger_group_Id"
                        name="ledger_group_Id"
                        value={formData.ledger_group_Id}
                        onChange={handleInputChange}
                        required
                    >
                        <option value="">Select</option>
                         {/* Map over the options array to generate the option elements dynamically */}
                         {masterData?.map((option) => (
                            <option key={option.ledger_group_Id} value={option.ledger_group_Id}>
                              {option.ledger_group_Name}
                            </option>
                          ))}
                    </Form.Select>
                    <CFormFeedback invalid>Select under</CFormFeedback>
                </CCol>
            </Row>
            <Row className="row-xs mb-2">
                <CCol md={8}>
                    <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="ledger_Opening_Balance">Opening Balance</CFormLabel>
                    <CFormInput
                        type="text"
                        id="ledger_Opening_Balance"
                        name="ledger_Opening_Balance"
                        value={formData.ledger_Opening_Balance}
                        onChange={handleInputChange}
                    />
                </CCol>
                <CCol md={4}>
                    <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="ledger_type">Type</CFormLabel>
                    <Form.Select
                        className="form-control"
                        id="ledger_type"
                        name="ledger_type"
                        value={formData.ledger_type}
                        onChange={handleInputChange}
                    >
                        <option value="">Select</option>
                        <option value="Dr">Dr</option>
                        <option value="Cr">Cr</option>
                    </Form.Select>
                </CCol>
            </Row>

            {/* Action Button */}
            <Row className="row-xs mb-2 btn-animation">
                <CCol xs={12} className="mt-10">
                    <CButton 
                        color="primary" 
                        className={`btn btn-sm float-end ${isSaveDisabled ? 'btn-loaders' : ''}` }
                        type="submit"
                        disabled={isSaveDisabled}
                    >
                        {isSaveDisabled ? (<span className="loading">Save Changes</span>) : "Save Changes"}
                    </CButton>
                    <CButton color="secondary" className="btn btn-sm float-end me-2" onClick={closeModal} disabled={isSaveDisabled}>Close</CButton>
                </CCol>
            </Row>
        </FormWrapper>
    );
};

export default LedgerAddEdit;
